import React from 'react';
import 'twin.macro';
import { useTranslation } from 'react-i18next';
import { SubscriptionCheckout } from '../../Billing/SubscriptionCheckout';
import Button from 'components/Buttons/Button';
import { Cart } from 'containers/Billing/types';
import { Plan } from 'types/plan';

interface Props {
  cart: Cart;
  setCart: (cart: Cart) => void;
  subscribablePlans: Plan[];
  isCheckoutDisabled: boolean;
  isLoading: boolean;
  isCheckoutLoading: boolean;
  onCheckout: () => Promise<void>;
  onPayByBankTransfer: () => void;
}

export function DirectorAddLicences({
  cart,
  setCart,
  subscribablePlans,
  isCheckoutDisabled,
  isCheckoutLoading,
  onCheckout,
  onPayByBankTransfer,
}: Props) {
  const { t } = useTranslation(['userSettings']);

  return (
    <SubscriptionCheckout
      plansTitle={t('userSettings:schoolSubscription.addLicenses')}
      cart={cart}
      onCartChange={setCart}
      plans={subscribablePlans}
      controls={
        <div tw="flex flex-col gap-2 mt-4">
          <Button
            intent="primary"
            disabled={isCheckoutDisabled}
            fill
            loading={isCheckoutLoading}
            onClick={onCheckout}
          >
            {t('userSettings:schoolSubscription.cta.payOnline')}
          </Button>
          <Button
            intent="primary"
            outlined
            disabled={isCheckoutDisabled}
            fill
            onClick={onPayByBankTransfer}
          >
            {t('userSettings:schoolSubscription.cta.payByBankTransfer')}
          </Button>
        </div>
      }
    />
  );
}
